import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import PageTitle2 from "../../../components/otherPages/PageTitle2";
import PrivacyPolicy from "../../../components/otherPages/PrivacyPolicy";
import React from "react";

import MetaComponent from "../../../components/common/MetaComponent";

export default function PrivacyPolicyPage() {

  const [MetaTitle, setMetaTitle] = React.useState("Privacy Policy || AskMeRealty - Real Estate Services");
  const [MetaDescription, setMetaDescription] = React.useState("AskMeRealty - Read our Privacy Policy to understand how we collect, use, and protect your personal information when you use our real estate services. Your privacy is important to us.");
  const [MetaKeywords, setMetaKeywords] = React.useState("Privacy Policy, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };
  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <PageTitle2 setMetaTitle={setMetaTitle} setMetaDescription={setMetaDescription} setMetaKeywords={setMetaKeywords} setMetaImage={setMetaImage} />
      <PrivacyPolicy />
      <Footer1 />
    </>
  );
}
